<template>
  <div class="performance">
    <div class="banner"></div>
    <div class="container-auto wrapper ">
      <workStatus></workStatus>
      <div class="flex justify-between mt-20">
        <performancePolicy></performancePolicy>
        <ServiceArea></ServiceArea>
      </div>
    </div>
  </div>
</template>

<script>
import WorkStatus from "@/views/performance/widget/workStatus.vue";
import PerformancePolicy from "@/views/performance/widget/policy.vue";
import ServiceArea from "@/views/performance/widget/serviceArea.vue";

export default {
  components: {ServiceArea, PerformancePolicy, WorkStatus}
}
</script>

<style scoped lang="scss">
.performance {
  .banner {
    width: 100%;
    height: 320px;
    background: url("~@/assets/img/performance/banner.png") no-repeat center center;
    background-size: 100% 100%;
  }

  .wrapper {
    margin-top: -40px;
    padding-bottom: 50px;
  }
}
</style>
